import { SET_CONFIG } from "./actions.js";
function intlReducer(state = null, action) {
  switch (action.type) {
    case SET_CONFIG:
      return {
        ...state,
        ...action.payload
      };
    default:
      return state;
  }
}
export {
  intlReducer as default
};
//# sourceMappingURL=reducer.js.map
